import createMessage from "./createMessage";
import BabyStationState from "../private/BabyStationState";

const name = "babyStationStateMessage";

function create(state) {
  const babyStationStateMessage = BabyStationState.create(state);

  return createMessage({ [name]: babyStationStateMessage });
}

export default {
  create,
  name
};

// BabyStationState babyStationStateMessage = 171;

// message BabyStationState {
//   int64 lastNoise = 1;
//   int64 lastMotion = 2;

//   DataRemoteSettings remoteSettings = 10;
//   BatteryStatus batteryStatus = 11;
//   CameraAndFlashlightState cameraAndFlashlightState = 12;
//   MotionDetectorState motionDetectorState = 13;
//   // app specific
//   LullabyPlayerState lullabyPlayerState = 40;
// }
